/* ============================================================
   VikingsBrand — Latin → Elder Futhark transliteration.

   SINGLE SOURCE OF TRUTH. Used by:
   - assets/vb-blade.js            (product.blade engraving configurator)
   - assets/vb-personalized.js     (collection.personalized rune demo)

   The handoff requires the PDP configurator and the collection demo
   to transliterate identically ("keep the two in sync, ideally one
   shared JS asset") — so neither file carries its own copy of the map.

   Rules (stated in the customer-facing copy on purpose, so nobody
   feels misled): Elder Futhark has 24 runes, so C/K/Q all collapse to
   ᚲ and V/W both become ᚹ; X is written ᚲᛊ. Spaces render as the
   word separator " · " used on real runic inscriptions, collapsed and
   never leading/trailing. Digits pass through unchanged. Unmapped
   characters are dropped. Local diacritics (Č Ć Š Ž Đ …) resolve
   explicitly or via their NFD base letter — they are never silently
   dropped.
   ============================================================ */
(function (w) {
  'use strict';

  var MAP = {
    A: 'ᚨ', B: 'ᛒ', C: 'ᚲ', D: 'ᛞ', E: 'ᛖ', F: 'ᚠ', G: 'ᚷ', H: 'ᚺ', I: 'ᛁ', J: 'ᛃ',
    K: 'ᚲ', L: 'ᛚ', M: 'ᛗ', N: 'ᚾ', O: 'ᛟ', P: 'ᛈ', Q: 'ᚲ', R: 'ᚱ', S: 'ᛊ', T: 'ᛏ',
    U: 'ᚢ', V: 'ᚹ', W: 'ᚹ', X: 'ᚲᛊ', Y: 'ᛇ', Z: 'ᛉ',
    'Þ': 'ᚦ', 'Ð': 'ᚦ', 'Æ': 'ᚨᛖ', 'Å': 'ᚨ', 'Ö': 'ᛟ',
    'Č': 'ᚲ', 'Ć': 'ᚲ', 'Š': 'ᛊ', 'Ž': 'ᛉ', 'Đ': 'ᛞ'
  };

  var SEP = ' · ';

  function toFuthark(str) {
    if (!str) return '';
    var out = '';
    var chars = String(str).toUpperCase().split('');
    for (var i = 0; i < chars.length; i++) {
      var ch = chars[i];
      if (ch === ' ') {
        if (out && out.slice(-SEP.length) !== SEP) out += SEP;
        continue;
      }
      if (/[0-9]/.test(ch)) { out += ch; continue; }
      if (MAP[ch]) { out += MAP[ch]; continue; }
      var base = ch.normalize ? ch.normalize('NFD').replace(/[̀-ͯ]/g, '') : ch;
      if (MAP[base]) out += MAP[base];
    }
    if (out.slice(-SEP.length) === SEP) out = out.slice(0, -SEP.length);
    return out;
  }

  w.VBFuthark = { map: MAP, separator: SEP, toFuthark: toFuthark };
})(window);
